//solve(board: number[4][4]): int from 0 to 3, 0 -> left, 1 -> up, 2-> right, 3-> down
const solve = (board) => {
    return Math.floor(Math.random() * 4);
}
export default solve;